var map = {
	"./allerum-golf-club/image-1.jpg": 56350,
	"./bokskogens-golf-club/image-1.jpg": 13118,
	"./forsbacka-golf-club/image-1.jpg": 3838,
	"./gumbalde-resort/image-1.jpg": 68881,
	"./isaberg-golf-club/image-1.jpg": 56651,
	"./karlshamn-golf-club/image-1.jpg": 15753,
	"./laholms-golf-club/image-1.jpg": 98302,
	"./landeryd-golf-club/image-1.jpg": 70291,
	"./linkoping-golf-club/image-1.jpg": 16095,
	"./malaro-golf-club/image-1.jpg": 24652,
	"./rya-golf-club/image-1.jpg": 18268,
	"./sjobo-golf-club/image-1.jpg": 40795,
	"./skerike-golf-club/image-1.jpg": 15300,
	"./soderslatt-golf-club/image-1.jpg": 32685,
	"./solvesborg-golf-club/image-1.jpg": 53358,
	"./trummenas-golf-club/image-1.jpg": 80268,
	"./upsala-golf-club/image-1.jpg": 8076,
	"./varberg-golf-club/image-1.jpg": 30589,
	"./vreta-kloster-golf-club/image-1.jpg": 5935
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93275;